module.exports = __webpack_public_path__ + "img/spaghetti_di_verdura_misti.1f8c41db.jpg";